var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModelComparisonOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.69922L6 7.69922",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.6992L2 12.6992",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.6992L7 14.9992",
    stroke: "#272D55",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0498 13.5488L11.5498 14.8488",
    stroke: "#272D55",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 10.4492L8.75 12.4492",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.69922L15 7.69922",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.19922C11.6046 4.19922 12.5 3.30379 12.5 2.19922C12.5 1.09465 11.6046 0.199219 10.5 0.199219C9.39543 0.199219 8.5 1.09465 8.5 2.19922C8.5 3.30379 9.39543 4.19922 10.5 4.19922Z",
    fill: "#AECDFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.69922C11.3284 3.69922 12 3.02765 12 2.19922C12 1.37079 11.3284 0.699219 10.5 0.699219C9.67157 0.699219 9 1.37079 9 2.19922C9 3.02765 9.67157 3.69922 10.5 3.69922Z",
    stroke: "#AECDFC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.1992C6.60457 11.1992 7.5 10.3038 7.5 9.19922C7.5 8.09465 6.60457 7.19922 5.5 7.19922C4.39543 7.19922 3.5 8.09465 3.5 9.19922C3.5 10.3038 4.39543 11.1992 5.5 11.1992Z",
    fill: "#AECDFC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.6992C6.32843 10.6992 7 10.0276 7 9.19922C7 8.37079 6.32843 7.69922 5.5 7.69922C4.67157 7.69922 4 8.37079 4 9.19922C4 10.0276 4.67157 10.6992 5.5 10.6992Z",
    stroke: "#AECDFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.1992C16.6046 11.1992 17.5 10.3038 17.5 9.19922C17.5 8.09465 16.6046 7.19922 15.5 7.19922C14.3954 7.19922 13.5 8.09465 13.5 9.19922C13.5 10.3038 14.3954 11.1992 15.5 11.1992Z",
    fill: "#AECDFC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10.6992C16.3284 10.6992 17 10.0276 17 9.19922C17 8.37079 16.3284 7.69922 15.5 7.69922C14.6716 7.69922 14 8.37079 14 9.19922C14 10.0276 14.6716 10.6992 15.5 10.6992Z",
    stroke: "#AECDFC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 14.1992C2.05228 14.1992 2.5 13.7515 2.5 13.1992C2.5 12.6469 2.05228 12.1992 1.5 12.1992C0.947715 12.1992 0.5 12.6469 0.5 13.1992C0.5 13.7515 0.947715 14.1992 1.5 14.1992Z",
    fill: "#AECDFC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 13.6992C1.77614 13.6992 2 13.4754 2 13.1992C2 12.9231 1.77614 12.6992 1.5 12.6992C1.22386 12.6992 1 12.9231 1 13.1992C1 13.4754 1.22386 13.6992 1.5 13.6992Z",
    stroke: "#AECDFC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15.6992C7.41421 15.6992 7.75 15.3634 7.75 14.9492C7.75 14.535 7.41421 14.1992 7 14.1992C6.58579 14.1992 6.25 14.535 6.25 14.9492C6.25 15.3634 6.58579 15.6992 7 15.6992Z",
    fill: "#AECDFC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15.1992C7.13807 15.1992 7.25 15.0873 7.25 14.9492C7.25 14.8111 7.13807 14.6992 7 14.6992C6.86193 14.6992 6.75 14.8111 6.75 14.9492C6.75 15.0873 6.86193 15.1992 7 15.1992Z",
    stroke: "#AECDFC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 13.9492C9.80228 13.9492 10.25 13.5015 10.25 12.9492C10.25 12.3969 9.80228 11.9492 9.25 11.9492C8.69772 11.9492 8.25 12.3969 8.25 12.9492C8.25 13.5015 8.69772 13.9492 9.25 13.9492Z",
    fill: "#AECDFC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 13.4492C9.52614 13.4492 9.75 13.2254 9.75 12.9492C9.75 12.6731 9.52614 12.4492 9.25 12.4492C8.97386 12.4492 8.75 12.6731 8.75 12.9492C8.75 13.2254 8.97386 13.4492 9.25 13.4492Z",
    stroke: "#AECDFC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5498 15.5996C11.964 15.5996 12.2998 15.2638 12.2998 14.8496C12.2998 14.4354 11.964 14.0996 11.5498 14.0996C11.1356 14.0996 10.7998 14.4354 10.7998 14.8496C10.7998 15.2638 11.1356 15.5996 11.5498 15.5996Z",
    fill: "#AECDFC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5498 15.0996C11.6879 15.0996 11.7998 14.9877 11.7998 14.8496C11.7998 14.7115 11.6879 14.5996 11.5498 14.5996C11.4117 14.5996 11.2998 14.7115 11.2998 14.8496C11.2998 14.9877 11.4117 15.0996 11.5498 15.0996Z",
    stroke: "#AECDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelComparisonOperationIcon);
export default __webpack_public_path__ + "static/media/ModelComparisonOperationIcon.4af20d5de2b1c99ef91f4c9081287689.svg";
export { ForwardRef as ReactComponent };